import { Navigate, Outlet, useLocation } from 'react-router'

import { useMe } from '@/auth/queries'

// Admin (site-operator) gate, layered on top of authentication: an authenticated
// Parent is sent back to the Parent app, an unauthenticated visitor to /login.
export function AdminRoute() {
  const me = useMe()
  const location = useLocation()

  if (me.isPending) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        role="status"
        aria-label="Checking your session"
      >
        <div className="border-muted-foreground/30 border-t-foreground h-8 w-8 animate-spin rounded-full border-4" />
      </div>
    )
  }

  if (me.isError || !me.data) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (me.data.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
